<template>
  <el-card shadow="never" style="margin-top: 10px">
    <div slot="header">
      <div style="width:100%;display: flex;align-items: center;justify-content: space-between;">
        <span>所查目标：{{ url }}</span>
        <el-button :disabled="error_disabled" size="small" @click="error_try()">失败重查</el-button>
      </div>
    </div>
    <div>
      <ul>
        <li>
          <div class="label" style="line-height: 140px">安全类</div>
          <div style="height: 140px" class="content">
            <div>
              <div class="waibu_content">QQ检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-QQ"></use>
                  </svg>
                  <span v-if="result.qq.code" :class="result.qq.color">{{ result.qq.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">微信检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-weixin"></use>
                  </svg>
                  <span v-if="result.vx.code" :class="result.vx.color">{{ result.vx.msg.substring(0, 8) }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">抖音检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-douyin"></use>
                  </svg>
                  <span v-if="result.dyjc.code" :class="result.dyjc.color">{{ result.dyjc.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">百度检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-baidu"></use>
                  </svg>
                  <span v-if="result.baidusafe.code" :class="result.baidusafe.color">{{ result.baidusafe.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">被墙污染检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-beiqiangjiance"></use>
                  </svg>
                  <span v-if="result.qiang.code" :class="result.qiang.color">{{ result.qiang.msg }}</span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">360安全检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-icon-360"></use>
                  </svg>
                  <span v-if="result.qihu360.code" :class="result.qihu360.color">{{ result.qihu360.msg }}</span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">域名hold检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-hold"></use>
                  </svg>
                  <span v-if="result.domainholdjc.code"
                        :class="result.domainholdjc.color">{{ result.domainholdjc.msg }}</span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
            </div>
            <div>
              <div class="waibu_content">飞书检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-feishu"></use>
                  </svg>
                  <span v-if="result.fsjc.code" :class="result.fsjc.color">{{ result.fsjc.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">金山检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-kingsoft"></use>
                    </svg>
                     <span v-if="result.jinshan.code" :class="result.jinshan.color">{{ result.jinshan.msg }}</span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">安全联盟检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-anquanlianmengrenzheng"></use>
                    </svg>
                   <span v-if="result.anquanjc.code" :class="result.anquanjc.color">{{ result.anquanjc.msg }}</span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">谷歌检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-guge"></use>
                    </svg>
                    <span v-if="result.googlechrome.code"
                          :class="result.googlechrome.color">{{ result.googlechrome.msg }}</span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">搜狗检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-sogou"></use>
                    </svg>
                    <span v-if="result.sogoujc.code" :class="result.sogoujc.color">{{ result.sogoujc.msg }}</span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">知乎检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-zhihu"></use>
                    </svg>
                    <span v-if="result.zhjc.code" :class="result.zhjc.color">{{ result.zhjc.msg }}</span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">简书检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-jianshu"></use>
                    </svg>
                    <span v-if="result.jianshu.code" :class="result.jianshu.color">{{ result.jianshu.msg }}</span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
            </div>
            <div>
              <div class="waibu_content">绿标检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-anquan"></use>
                  </svg>
                  <span v-if="result.gl.code" :class="result.gl.color">{{ result.gl.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">微博检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-weibo"></use>
                  </svg>
                  <span v-if="result.wbjc.code" :class="result.wbjc.color">{{ result.wbjc.msg }}</span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">小米检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-xiaomi"></use>
                    </svg>
                    <span v-if="result.mi.code" :class="result.mi.color">{{ result.mi.msg }}</span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="label" style="line-height: 100px;">域名类</div>
          <div style="height: 100px" class="content">
            <div>
              <div class="waibu_content">whois:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-yuming"></use>
                  </svg>
                  <span v-if="result.whois.code" :class="result.whois.color">
                        {{ result.whois.code == 200 ? '已注册' : result.whois.msg }}
                      </span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div v-if="result.whois.code==200" class="waibu_content">所有者:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-yuming"></use>
                    </svg>
                    <span>
                      {{ result.whois.data.owner ? result.whois.data.owner : '未知' }}
                    </span>
                  </div>
              </div>
              <div v-if="result.whois.code==200" class="waibu_content">服务商:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-yuming"></use>
                  </svg>
                  <span>{{ result.whois.data.registrar }}</span>
                </div>
              </div>
            </div>
            <div>
              <div v-if="result.whois.code==200" class="waibu_content">注册时间:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-yuming"></use>
                  </svg>
                  <span>{{ result.whois.data.creationDate * 1000 | dateFormat }}</span>
                </div>
              </div>
              <div v-if="result.whois.code==200" class="waibu_content">到期时间:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-yuming"></use>
                    </svg>
                    <span>{{ result.whois.data.expirationDate * 1000 | dateFormat }}</span>
                  </div>
              </div>
              <div v-if="result.whois.code==200" class="waibu_content">域名状态:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-yuming"></use>
                    </svg>
                    <span>{{ result.whois.data.states }}</span>
                  </div>
              </div>
            <div v-if="result.whois.code==200" class="waibu_content">DNS服务器:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-yuming"></use>
                  </svg>
                  <span>{{ result.whois.data.nameServers[0] }}</span>
                </div>
                <div v-if="result.whois.code==200" class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-yuming"></use>
                  </svg>
                  <span>{{ result.whois.data.nameServers[1] }}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="label" style="line-height: 180px">备案资质类</div>
          <div style="height: 180px" class="content">
            <div>
              <div class="waibu_content">ICP备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-beian"></use>
                  </svg>
                  <span v-if="result.icp.code" :class="result.icp.color">
                        {{ result.icp.msg }}
                      </span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div v-if="result.icp.code ==200" class="waibu_content">备案号:
                  <div class="icon_box">
                    {{result.icp.data?.serviceLicence}}
                  </div>
              </div>
              <div v-if="result.icp.code ==200" class="waibu_content">备案主体:
                <div class="icon_box">
                  {{ result.icp.data?.unitName}}
                </div>
              </div>
              <div v-if="result.icp.code ==200" class="waibu_content">备案类型:
                <div class="icon_box">
                  {{ result.icp.data?.natureName}}
                </div>
              </div>
              <div v-if="result.icp.code ==200" class="waibu_content">审核时间:
                <div class="icon_box">
                  {{
                    result.icp.data?.updateRecordTime
                  }}
                </div>
              </div>
            </div>
            <div>
              <div class="waibu_content">网安备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-gonganxitong"></use>
                  </svg>
                  <span v-if="result.wangan.code" :class="result.wangan.color">
                        {{ result.wangan.msg }}
                      </span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">网站名:
                <div class="icon_box">
                  {{ result.wangan.data.siteName }}
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">备案号:
                <div class="icon_box">
                  {{ result.wangan.data.BeianName }}
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">备案主体:
                <div class="icon_box">
                  {{ result.wangan.data.unitName }}({{ result.wangan.data.nature }})
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">网站类型:
                <div class="icon_box">
                  {{ result.wangan.data.type }}
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">审核地:
                <div class="icon_box">
                  {{ result.wangan.data.BeianAddr }}
                </div>
              </div>
              <div v-if="result.wangan.code ==200" class="waibu_content">审核时间:
                <div class="icon_box">
                  {{ result.wangan.data.BeianTime }}
                </div>
              </div>
            </div>
            <div>
              <div class="waibu_content">管局黑名单检测:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-heimingdan"></use>
                  </svg>
                  <span v-if="result.icpblack.code" :class="result.icpblack.color">
                        {{ result.icpblack.msg }}
                      </span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
            </div>
            <div>
              <div class="waibu_content">阿里云备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-aliyun"></use>
                  </svg>
                  <span v-if="result.aliyun.code" :class="result.aliyun.color">
                        {{ result.aliyun.msg }}
                      </span>
                  <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">腾讯云备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-tengxunyun-chanyezhibianyunqiweilai"></use>
                  </svg>
                  <span v-if="result.tencent.code" :class="result.tencent.color">
                    {{ result.tencent.msg }}
                  </span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">百度云备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-baiduyunguanli"></use>
                  </svg>
                  <span v-if="result.baidu.code" :class="result.baidu.color">
                    {{ result.baidu.msg }}
                  </span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">西部数码备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-west"></use>
                  </svg>
                  <span v-if="result.west.code" :class="result.west.color">
                    {{ result.west.msg }}
                  </span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
              <div class="waibu_content">景安备案:
                <div class="icon_box">
                  <svg aria-hidden="true" class="icon">
                    <use xlink:href="#icon-changjinganfangjiance"></use>
                  </svg>
                  <span v-if="result.zzidc.code" :class="result.zzidc.color">
                    {{ result.zzidc.msg }}
                  </span>
                   <i v-else class="el-icon-loading"></i>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="label" style="line-height: 140px">网络类</div>
          <div style="height: 140px" class="content">
            <div>
               <div class="waibu_content">链接状态检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-fuwulianjiezhuangtai"></use>
                    </svg>
                    <span v-if="result.httpcode.code" :class="result.httpcode.color">
                          {{ result.httpcode.msg }}
                        </span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
               </div>
            </div>
            <div>
                <div class="waibu_content">Ping检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-ping"></use>
                    </svg>
                    <span v-if="result.ping.code" :class="result.ping.color">
                          {{ result.ping.msg }}
                        </span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
                </div>
                <div v-if="result.ping.code ==200" class="waibu_content">延时:
                    <div class="icon_box">
                      {{ result.ping.data.ping_avg }}
                    </div>
                  </div>
                <div v-if="result.ping.code ==200" class="waibu_content">IP地址:
                    <div class="icon_box">
                      {{ result.ping.data.ip }}
                    </div>
                </div>
                <div v-if="result.ping.code ==200" class="waibu_content">所在地:
                    <div class="icon_box">
                      {{ result.ping.data.server_address }}
                    </div>
                </div>
                <div v-if="result.ping.code ==200" class="waibu_content">CNAME:
                    <div class="icon_box">
                      {{ result.ping.data.cname }}
                    </div>
                </div>
            </div>
            <div>
               <div class="waibu_content">端口Ping检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-ping"></use>
                    </svg>
                    <span v-if="result.tcping.code" :class="result.tcping.color">
                          {{ result.tcping.msg }}
                        </span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div v-if="result.tcping.code ==200" class="waibu_content">延时:
                  <div class="icon_box">
                    {{ result.tcping.data.ping_avg }}
                  </div>
              </div>
              <div v-if="result.tcping.code ==200" class="waibu_content">IP地址:
                  <div class="icon_box">
                    {{ result.tcping.data.ip }}
                  </div>
              </div>
              <div v-if="result.tcping.code ==200" class="waibu_content">所在地:
                  <div class="icon_box">
                    {{ result.tcping.data.server_address }}
                  </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="label" style="line-height: 60px;">索引收录类</div>
          <div style="height: 60px" class="content">
            <div>
               <div class="waibu_content">百度PC收录检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-baidu"></use>
                    </svg>
                    <span v-if="result.baiduincluded.code" :class="result.baiduincluded.color">
                          {{ result.baiduincluded.msg }}
                        </span>
                    <i v-else class="el-icon-loading"></i>
                  </div>
               </div>
              <div class="waibu_content">360PC收录检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-icon-360"></use>
                    </svg>
                    <span v-if="result.soincluded.code" :class="result.soincluded.color">
                      {{ result.soincluded.msg }}
                    </span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">搜狗PC收录检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-sogou"></use>
                    </svg>
                    <span v-if="result.sogouincluded.code" :class="result.sogouincluded.color">
                      {{ result.sogouincluded.msg }}
                    </span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
              <div class="waibu_content">谷歌PC收录检测:
                  <div class="icon_box">
                    <svg aria-hidden="true" class="icon">
                      <use xlink:href="#icon-guge"></use>
                    </svg>
                    <span v-if="result.googleincluded.code" :class="result.googleincluded.color">
                      {{ result.googleincluded.msg }}
                    </span>
                     <i v-else class="el-icon-loading"></i>
                  </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import {publicEncryptedData} from '@/utils/encrypted'
import '@/../public/iconfont/zhjc_iconfont'

export default {
  props: ['url', 'ctoken'],
  data() {
    return {
      baseUrl: 'https://api.user.urlzt.com/api/',
      form: {
        token: this.$store.state.isLogin ? localStorage.getItem('key') : undefined,
        url: '',
        ctoken: undefined,
      },
      error_disabled: true,
      total_api_back: 0,
      error_api_back: 0,
      jctype: ['zhjc', 'qq', 'vx', 'baidusafe', 'icp', 'wangan', 'gl', 'qiang', 'httpcode', 'ping', 'tcping', 'mi', 'whois', 'jinshan', 'dyjc', 'wbjc', 'fsjc', 'anquanjc', 'domainholdjc', 'icpblack', 'aliyun', 'tencent', 'baidu', 'west', 'zzidc', 'googlechrome', 'qihu360', "jianshu", "baiduincluded", "soincluded", "sogouincluded", "googleincluded", "sogoujc"],
      result: {
        qq: {},
        vx: {},
        baidusafe: {},
        icp: {},
        wangan: {},
        gl: {},
        qiang: {},
        httpcode: {},
        ping: {},
        tcping: {},
        mi: {},
        whois: {},
        jinshan: {},
        dyjc: {},
        wbjc: {},
        fsjc: {},
        anquanjc: {},
        mpjc: {},
        domainholdjc: {},
        icpblack: {},
        aliyun: {},
        tencent: {},
        baidu: {},
        west: {},
        zzidc: {},
        zhjc: {},
        googlechrome: {},
        qihu360: {},
        jianshu: {},
        baiduincluded: {},
        soincluded: {},
        sogouincluded: {},
        googleincluded: {},
        sogoujc: {}
      },
      showalert: false,
    }
  },
  created() {
    // this.form.url = this.url
  },
  mounted() {
    this.jctype.forEach(item => {
      this.form.url = this.url
      console.log(this.result[item])
      // this.result[item].code = false
      this.post_url(item)
    })
  },
  methods: {
    // 统一的获取方法
    async post_url(url) {
      let url_a = this.baseUrl + url
      try {
        if (!this.$store.state.isLogin && this.ctoken && !this.form.token) {
          let newForm = JSON.parse(JSON.stringify(this.ctoken))
          newForm.api = url
          newForm.time = Date.now()
          this.form.ctoken =  publicEncryptedData(JSON.stringify(newForm), 'encrypt')
        }
        const {data: res} = await this.$http.post(url_a, this.form, {timeout: 20000})
        let data
        if (typeof res == 'string') {
          data = JSON.parse(res)
        } else {
          data = res
        }
        if (data.code == 200) {
          data.color = 'green'
        } else if (data.code == -1) {
          data.color = 'gray'
          if (!this.showalert) {
            this.showalert = true
            this.show_alert(data.msg)
          }
          data.msg = '未检测'
          this.error_api_back += 1
        } else if (data.code == 500) {
          data.msg = '失败'
          data.color = 'yellow'
          this.error_api_back += 1
        } else {
          data.color = 'red'
        }
        this.result[url]=data
        this.total_api_back += 1
        if (this.total_api_back == this.jctype.length) {
          this.error_disabled = false
          this.$emit('checkok')
        }
      } catch (e) {
        this.total_api_back += 1
        this.error_api_back += 1
        this.result[url] = {code: 500, msg: '失败', color: 'yellow'}
        if (this.total_api_back == this.jctype.length) {
          this.error_disabled = false
          this.$emit('checkok')
        }
      }
    },
    show_alert(msg) {
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'error'
      })
    },
    //失败重查
    error_try() {
      if (this.error_api_back == 0) return this.$message.error('没有失败的检测')
      this.showalert = false
      for (let key in this.result) {
        if (this.result[key].code == 500 || this.result[key].code == -1) {
          this.total_api_back -= 1
          this.error_api_back -= 1
          this.error_disabled = true
          this.$set(this.result[key],'code',false)
          this.post_url(key)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.icon {
  width: 1.4em;
  height: 1.4em;
  vertical-align: -0.25em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 5px;
}

ul {
  padding: 0;
  border: 1px solid #e4eef6;
  border-bottom: 0;

  li {
    overflow: hidden;
    list-style: none;
    border-bottom: 1px solid #e4eef6;

    .label {
      float: left;
      width: 100px;
      line-height: 50px;
      font-size: 12px;
      text-align: center;
      background-color: #f0f7fc;
      border-right: 1px solid #e4eef6;
    }

    .content {
      margin-left: 100px;
      padding: 10px;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      box-sizing: border-box;
      //p {
      //  display: flex;
      //  height: 40px;
      //  align-items: center;
      //  margin: 0;
      //}

      .waibu_content {
        display: inline-block;
        margin: 0 10px;
      }

      .icon_box {
        display: inline-block;
        border: 1px solid #DCDFE6;
        padding: 2px 5px;

        span {
          border-left: 1px solid #DCDFE6;
          padding-left: 5px;
          white-space: nowrap;
        }

        .green {
          color: #67C23A;
        }

        .red {
          color: #F56C6C;
        }

        .gray {
          color: #909399;
        }

        .yellow {
          color: #E6A23C;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  ul {
    li {
      .label {
        width: 100%;
        float: unset;
        line-height: 50px !important;
      }

      .content {
        margin-left: 0;

        p {
          height: unset;
          flex-wrap: wrap;
          line-height: 22px;

          .waibu_content {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
